module.exports = __webpack_public_path__ + "static/media/david.b361625d.png";